import {
  // CONTROL PLANS
  GET_PLANS_CONTROL,
  GET_PLANS_CONTROL_SUCCESS,
  POST_PLAN_CONTROL,
  PATCH_PLAN_CONTROL,
  DELETE_PLAN_CONTROL,
  DUPLICATE_PLAN_CONTROL,
  // CONTROLS
  GET_ALL_CONTROL_PLANS_AND_CONTROLS,
  GET_ALL_CONTROL_PLANS_AND_CONTROLS_SUCCESS,
  GET_CONTROL_PLAN_AND_CONTROLS,
  GET_CONTROL_PLAN_AND_CONTROLS_SUCCESS,
  GET_CONTROL_AND_TEMPLATE_BY_ID,
  GET_CONTROL_AND_TEMPLATE_BY_ID_SUCCESS,
  POST_CONTROL,
  DUPLICATE_CONTROL,
  PATCH_CONTROL_99,
  PATCH_CONTROL_FROM_PLANNING_CONTROL,
  PATCH_CONTROL_FROM_MAPPING_RISK,
  AFFECT_USERS_CONTROL,
  DELETE_CONTROL,
  GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS,
  GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS_SUCCESS,
  SET_CONTROLS_THAT_HAVE_RECOMMENDATIONS,
  GET_OVERALL_SYNTHESE_CONTROL,
  GET_OVERALL_SYNTHESE_CONTROL_SUCCESS,
  // FILES CONTROLS
  POST_FILES_CONTROL,
  POST_FILES_CONTROL_SUCCESS,
  DELETE_FILES_CONTROL,
  DELETE_FILES_CONTROL_SUCCESS,
  CLEAN_FILES_CONTROL,
  // CONTROL POINTS
  GET_CONTROL_POINTS,
  POST_CONTROL_POINT,
  DUPLICATE_CONTROL_POINT,
  PATCH_CONTROL_POINT,
  DELETE_CONTROL_POINT,
  // CONTROL THREAD
  GET_CONTROL_THREAD_BY_CONTROL_ID,
  GET_CONTROL_THREAD_BY_CONTROL_ID_SUCCESS,
  POST_MESSAGE_CONTROL_THREAD,
  // VALIDATION CONTROLS
  MANAGER_VALID_CONTROL,
  MANAGER_REJECT_CONTROL,
  CLIENT_VALID_CONTROL,
  CLIENT_REJECT_CONTROL,
  // ALL DATAS CONTROL PLANNING
  GET_ALL_DATAS_CONTROL_PLANNING_V2,
  SET_IS_LOADING_CONTROL,
  SET_IS_LOADING_SYNTHESE,
  // VALIDATION CONTROLS PARAMETERS AND TEMPLATE WORKFLOW 99
  CONFIRM_CONTROL_VALIDATION,
} from "./constants"

// PLAN CONTROL
export function getPlansControlAction() {
  return {
    type: GET_PLANS_CONTROL,
  }
}

export function getPlansControlSuccessAction(payload) {
  return {
    type: GET_PLANS_CONTROL_SUCCESS,
    payload: payload,
  }
}

export function postPlanControlAction(payload) {
  return {
    type: POST_PLAN_CONTROL,
    payload: payload,
  }
}

export function patchPlanControlAction(payload) {
  return {
    type: PATCH_PLAN_CONTROL,
    payload: payload,
  }
}

export function deletePlanControlAction(payload) {
  return {
    type: DELETE_PLAN_CONTROL,
    payload: payload,
  }
}

export function duplicatePlanControlAction(payload) {
  return {
    type: DUPLICATE_PLAN_CONTROL,
    payload: payload,
  }
}

// CONTROLS

export function getAllControlPlansAndControlsAction(payload) {
  return {
    type: GET_ALL_CONTROL_PLANS_AND_CONTROLS,
    payload: payload,
  }
}

export function getAllControlPlansAndControlsSuccessAction(payload) {
  return {
    type: GET_ALL_CONTROL_PLANS_AND_CONTROLS_SUCCESS,
    payload: payload,
  }
}

export function getControlPlanAndControlsAction(payload) {
  return {
    type: GET_CONTROL_PLAN_AND_CONTROLS,
    payload: payload,
  }
}

export function getControlPlanAndControlsuccessAction(payload) {
  return {
    type: GET_CONTROL_PLAN_AND_CONTROLS_SUCCESS,
    payload: payload,
  }
}

export function getControlAndTemplateByIdAction(payload) {
  return {
    type: GET_CONTROL_AND_TEMPLATE_BY_ID,
    payload: payload,
  }
}

export function getControlAndTemplateByIdSuccessAction(payload) {
  return {
    type: GET_CONTROL_AND_TEMPLATE_BY_ID_SUCCESS,
    payload: payload,
  }
}

export function postControlAction(payload) {
  return {
    type: POST_CONTROL,
    payload: payload,
  }
}

export function duplicateControlAction(payload) {
  return {
    type: DUPLICATE_CONTROL,
    payload: payload,
  }
}

export function patchControl99Action(payload) {
  return {
    type: PATCH_CONTROL_99,
    payload: payload,
  }
}

export const patchControlFromPlanningControlAction = payload => ({
  type: PATCH_CONTROL_FROM_PLANNING_CONTROL,
  payload,
})

export function affectUsersControlAction(payload) {
  return {
    type: AFFECT_USERS_CONTROL,
    payload: payload,
  }
}

export function deleteControlAction(payload) {
  return {
    type: DELETE_CONTROL,
    payload: payload,
  }
}

export function getControlsThatHaveRecommendationsAction(payload) {
  return {
    type: GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS,
    payload: payload,
  }
}

export function setControlsThatHaveRecommendationsAction(payload) {
  return {
    type: SET_CONTROLS_THAT_HAVE_RECOMMENDATIONS,
    payload: payload,
  }
}

export function getControlsThatHaveRecommendationsSuccessAction(payload) {
  return {
    type: GET_CONTROLS_THAT_HAVE_RECOMMENDATIONS_SUCCESS,
    payload: payload,
  }
}

export function getOverallSyntheseControlAction(payload) {
  return {
    type: GET_OVERALL_SYNTHESE_CONTROL,
    payload: payload,
  }
}

export function getOverallSyntheseControlSuccessAction(payload) {
  return {
    type: GET_OVERALL_SYNTHESE_CONTROL_SUCCESS,
    payload: payload,
  }
}

// FILES CONTROL ACTION


export function postFilesControlAction(payload) {
  return {
    type: POST_FILES_CONTROL,
    payload: payload,
  }
}

export function postFilesControlSuccessAction(payload) {
  return {
    type: POST_FILES_CONTROL_SUCCESS,
    payload: payload,
  }
}

export function deleteFilesControlAction(payload) {
  return {
    type: DELETE_FILES_CONTROL,
    payload: payload,
  }
}
export function deleteFilesControlSuccessAction(payload) {
  return {
    type: DELETE_FILES_CONTROL_SUCCESS,
    payload: payload,
  }
}

export function cleanFilesControlAction() {
  return {
    type: CLEAN_FILES_CONTROL,
  }
}

// CONTROL POINTS
export function postControlPointsAction(payload) {
  return {
    type: POST_CONTROL_POINT,
    payload: payload,
  }
}
export function duplicateControlPointsAction(payload) {
  return {
    type: DUPLICATE_CONTROL_POINT,
    payload: payload,
  }
}
export function patchControlPointsAction(payload) {
  return {
    type: PATCH_CONTROL_POINT,
    payload: payload,
  }
}
export function deleteControlPointsAction(payload) {
  return {
    type: DELETE_CONTROL_POINT,
    payload: payload,
  }
}

// CONTROL THREAD
export function getControlThreadByControlIdAction(payload) {
  return {
    type: GET_CONTROL_THREAD_BY_CONTROL_ID,
    payload: payload,
  }
}

export function getControlThreadByControlIdSuccessAction(payload) {
  return {
    type: GET_CONTROL_THREAD_BY_CONTROL_ID_SUCCESS,
    payload: payload,
  }
}

export function postMessageToControlThreadAction(payload) {
  return {
    type: POST_MESSAGE_CONTROL_THREAD,
    payload: payload,
  }
}

// VALIDATION CONTROLS PARAMETERS AND TEMPLATE WORKFLOW 99
export function confirmControlAction(payload) {
  return {
    type: CONFIRM_CONTROL_VALIDATION,
    payload: payload,
  }
}

// VALIDATION CONTROLS
export function managerValidControlAction(payload) {
  return {
    type: MANAGER_VALID_CONTROL,
    payload: payload,
  }
}

export function managerRejectControlAction(payload) {
  return {
    type: MANAGER_REJECT_CONTROL,
    payload: payload,
  }
}

export function clientValidControlAction(payload) {
  return {
    type: CLIENT_VALID_CONTROL,
    payload: payload,
  }
}

export function clientRejectControlAction(payload) {
  return {
    type: CLIENT_REJECT_CONTROL,
    payload: payload,
  }
}

//REGROUP REQUEST CONTROL / RESPONSES / DOCUMENTS / THREAD
export function getAllDatasControlPlanningV2Action(payload) {
  return {
    type: GET_ALL_DATAS_CONTROL_PLANNING_V2,
    payload: payload,
  }
}

export function setIsLoadingControlAction(payload) {
  return {
    type: SET_IS_LOADING_CONTROL,
    payload: payload,
  }
}

export function setIsLoadingSyntheseAction(payload) {
  return {
    type: SET_IS_LOADING_SYNTHESE,
    payload: payload,
  }
}
